var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"workspace-shortcut",attrs:{"aria-live":"polite"}},[_c('b-spinner',{attrs:{"small":""}}),_c('span',[_vm._v("Открываем вашу вкладку…")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }